import { getAxios } from '../../../../lib/axios';
import { ActivityEndpoints } from '../../../../constants/endpoints/activityEndpoints.ts';
import { useQuery } from '@tanstack/react-query';
import { AddressV2 } from '../../../../globalModels/locations/address';
import { FrontierRoomTypeViewModel } from '../../../../globalModels/hotels/frontier/frontierRoomTypes';
import { ServiceFeeTemplateModel } from '../../../../features/crmAdmin/serviceFees/types';

type ActivityInformationCompanyModel = {
  ReportingRequirementNotes: string;
  CodingRequirements: string;
  AgentNotes: string[];
  CodeRedNotes: string[];
  RequiredAmenities: string[];
  AmenityNotes: string | undefined;
  ApprovalProcess: string | undefined;
  AuthorizedBookerPolicy: string | undefined;
  CheckInRequirements: string | undefined;
  PaymentNote: string | undefined;
  RoomingPolicy: string | undefined;
  TravelPolicy: string | undefined;
  VipTravellersPolicy: string | undefined;
  GdsCardLastFour: string | undefined;
  CompanyName: string | undefined;
  Address: AddressV2;
  UnpreferredNotes: ActivityInformationCompanyUnpreferredHotel[];
  PreferredNotes: ActivityInformationCompanyPreferredHotel[];
  ServiceFeeTemplate: ServiceFeeTemplateModel | undefined;
  AutomatedApprovalSystemNotes: string | undefined;
};

type ActivityInformationCompanyUnpreferredHotel = {
  Id: number;
  Name: string;
  CityName: string;
  Note: string;
};
type ActivityInformationCompanyPreferredHotel = {
  HotelId: number;
  Name: string;
  CityName: string;
  Note: string;
  RoomTypes: FrontierRoomTypeViewModel[];
  RateUrl: string;
  RateSheetHandle: string;
  RateSheetFileName: string;
};

export function useActivityInformationCompanyQuery(companyId?: number, enabled: boolean = true) {
  return useQuery<ActivityInformationCompanyModel>({
    queryKey: ['activity-information-company', companyId],
    queryFn: async () => (await getAxios().get(ActivityEndpoints.information.company(companyId!))).data,
    enabled: enabled && !!companyId
  });
}
